import { Avatar } from "@mui/material";
import Image from "next/image";
import { useQuery } from "react-query";
import { CountriesAPI } from "@/lib/http";
import { useState } from "react";
import { BiGlobe, BiImage } from "react-icons/bi";
import { getImageUrl } from "@/lib/utils";
import { setCookie } from "cookies-next/client";
import { useDispatch } from "react-redux";
import { updateCountry } from "@/lib/store/slice/appSlice";
import Link from "next/link";

const CountryList = ({ close }: { close: () => void }) => {
  const dispatch = useDispatch();
  const [countryData, setCountryData] = useState<Record<string, string>[]>([]);
  useQuery(
    ["get-all-countries"],
    () =>
      CountriesAPI.api("get", {
        postfix: `?Active=1`,
      }),
    {
      onSuccess(data) {
        if (data?.status === 200)
          setCountryData(data?.data instanceof Array ? data.data : []);
      },
    }
  );

  return (
    <div
      onMouseLeave={close}
      className="bg-white p-5 absolute shadow top-[80px]  right-0   rounded-md "
    >
      <ul className="grid grid-cols-3 md:grid-cols-6 gap-10 cursor-pointer">
        {countryData?.map((c) => {
          return (
            <Link
              href={`/${c?.Slug}`}
              key={c?.Slug}
              className=" text-base flex flex-col justify-center items-center  font-normal hover:scale-110 transition-all duration-300 hover:duration-500   "
              onClick={() => {
                close();
                // window.location.href ="/"
                dispatch(updateCountry(c?.Slug || ""));
                setCookie("country", c?.Slug);
                setCookie("countrycode", c?.CountryCode);
              }}
            >
              <Avatar
                sx={{
                  backgroundColor: "white",
                  border: "1px solid #eee",
                  borderRadius: "5px",
                  width: 70,
                  height: 50,
                  margin: "auto",
                }}
              >
                {c?.CountryFlag ? (
                  <Image
                    src={getImageUrl(c?.CountryFlag, "country") || ""}
                    alt="product"
                    fill={true}
                    className="w-full object-contain"
                    loading="lazy"
                  />
                ) : (
                  <BiImage size={35} />
                )}
              </Avatar>
              <p className="text-sm font-medium text-gray-600">
                {c.CountryName}
              </p>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default CountryList;
